import * as type from './type';
import util from 'common/js/util';

export default{
    //获取商品列表
    [type.GET_PRODUCT_LIST](context,option){
        util.post({
            params: {
                functionId: 'productSearch',
                body: JSON.stringify(option.params)
            },
            sc (resp){
                context.commit(type.SET_IS_REQUEST_SUCCESS, true);
                let wares = resp.data.wares;
                let params = option.params;
                // 存储获取到的纠错后的关键字
                context.commit(type.SET_OLD_KEYWORD, resp.data.oldKeyWord);
                // 默认纠错false
                context.commit(type.SET_RE_CORRECT, false);
                // 存储总页数
                context.commit(type.SET_PAGE_COUNT, resp.data.pageCount);
                if(wares.length > 0){
                    for(let item of wares){
                        if(item.price){
                            item.priceTxt = "￥" + item.price;
                        }else{
                            item.priceTxt = "暂无报价";
                        }
                    }
                }
                if(params.page == 1){
                    context.commit(type.SET_PRODUCT_LIST, wares);
                } else if (params.page == 1 && params.totalCount == 1 && params.wares == '') { // 主要用于纠错后数据为空时显示托底
                    context.commit(type.SET_PRODUCT_LIST, '');
                } else {
                    context.commit(type.SET_PRODUCT_LIST, [...context.state.productList, ...wares]);
                }
                // context.commit(type.SET_NO_MORE, context.state.productList.length >= resp.data.totalCount);
                context.commit(type.SET_NO_MORE,  option.params.page * option.params.pageSize >= resp.data.totalCount);
                if(option && option.sc){
                    option.sc && option.sc(wares);
                }
            },
            fc(data){
                context.commit(type.SET_IS_REQUEST_SUCCESS, true);
                context.commit(type.SET_PRODUCT_LIST, []);
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //通过三级类目获取商品列表
    [type.GET_LIST_BY_CATEGORY](context,option){
        util.post({
            params: {
                functionId: 'searchWareByCategory',
                body: JSON.stringify(option.params)
                // keyword:option.params.keyword,
                // page: option.params.page,
                // pageSize: option.params.pageSize,
            },
            sc (resp){
                context.commit(type.SET_IS_REQUEST_SUCCESS, true);
                let wares = resp.data.wares;
                let params = option.params;
                // 存储总页数
                context.commit(type.SET_PAGE_COUNT, resp.data.pageCount);

                if(wares.length > 0){
                    for(let item of wares){
                        if(item.price){
                            item.priceTxt = "￥" + item.price;
                        }else{
                            item.priceTxt = "暂无报价";
                        }
                    }
                }
                if(params.currentPage == 1){
                    context.commit(type.SET_PRODUCT_LIST, wares);
                } else {
                    context.commit(type.SET_PRODUCT_LIST, [...context.state.productList, ...wares]);
                }
                // context.commit(type.SET_NO_MORE, context.state.productList.length >= resp.data.totalCount);
                context.commit(type.SET_NO_MORE, option.params.currentPage * option.params.pageSize >= resp.data.totalCount);
                if(option && option.sc){
                    option.sc && option.sc(wares);
                }
            },
            fc(data){
                context.commit(type.SET_IS_REQUEST_SUCCESS, true);
                context.commit(type.SET_PRODUCT_LIST, []);
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //通过品牌ID和二级类目ID获取商品列表
    [type.GET_LIST_BY_BRAND](context,option){
        util.post({
            params: {
                functionId: 'brandWareList',
                body: JSON.stringify(option.params)
            },
            sc (resp){
                context.commit(type.SET_IS_REQUEST_SUCCESS, true);
                let wares = resp.data.wares;
                let params = option.params;

                if(wares.length > 0){
                    for(let item of wares){
                        if(item.price){
                            item.priceTxt = "￥" + item.price;
                        }else{
                            item.priceTxt = "暂无报价";
                        }
                    }
                }
                if(params.page == 1){
                    context.commit(type.SET_PRODUCT_LIST, wares);
                } else {
                    context.commit(type.SET_PRODUCT_LIST, [...context.state.productList, ...wares]);
                }
                // context.commit(type.SET_NO_MORE, context.state.productList.length >= resp.data.totalCount);
                context.commit(type.SET_NO_MORE, option.params.page * option.params.pageSize >= resp.data.totalCount);
                if(option && option.sc){
                    option.sc && option.sc(wares);
                }
            },
            fc(data){
                context.commit(type.SET_IS_REQUEST_SUCCESS, true);
                context.commit(type.SET_PRODUCT_LIST, []);
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/store/search-bar/actions.js